// src/pages/FreedomOfSpeechPolicy.jsx

import React from 'react';
import HeaderWrapper from "../components/common/HeaderWrapper";

const FreedomOfSpeechPolicy = () => {
    return (
        <div className="home-container body-font">
            <HeaderWrapper />
            <div className="main-background home-main-background">
                <div className="content-wrapper home-content-wrapper" style={{ padding: '20px', margin: '0 auto' }}>
                    <h1 className="terms-main-title">Freedom of Speech Policy</h1>
                    <div className="content-section">
                        <div className="content-text">
                            <p>
                                <b>Yourplat4orm.com</b> is owned by British journalists who place great value on <b>freedom of speech</b> and <b>freedom of expression</b>. We believe that it is our duty to uphold those freedoms responsibly.
                            </p>
                            <p>
                                If we consider your content is truthful and accurate, we will always <b>allow publication and challenge any attempt at removal</b>, whether we agree with its sentiments or not.
                            </p>
                            <p>
                                <b>BUT</b> if we deem your content to be libellous, deliberately inaccurate, or designed to provoke an inhumane response, <b>it will be taken down and further action may be taken as we see fit.</b>
                            </p>
                        </div>
                        <div className="content-image-flex">
                            <img src={require('../assets/talent.png')} alt="Freedom of Speech" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FreedomOfSpeechPolicy;